/* ══════════════════════════════════════
   Kishori Jewelry — Custom Wishlist JS
   v2.0 — localStorage based, Free Forever
   Rendering handled by Liquid section.
   This file: data + events + hearts + toast
══════════════════════════════════════ */

var KishoriWishlist = {

  KEY: 'kishori_wishlist',

  /* ── GET all wishlist items ── */
  get: function() {
    try {
      return JSON.parse(localStorage.getItem(this.KEY)) || [];
    } catch(e) {
      return [];
    }
  },

  /* ── SAVE wishlist ── */
  save: function(items) {
    try {
      localStorage.setItem(this.KEY, JSON.stringify(items));
    } catch(e) {}
  },

  /* ── ADD product ── */
  add: function(product) {
    var items = this.get();
    var exists = items.find(function(i) { return i.id === product.id; });
    if (!exists) {
      items.push(product);
      this.save(items);
    }
    this.updateCount();
    return true;
  },

  /* ── REMOVE product ── */
  remove: function(productId) {
    var items = this.get().filter(function(i) { return i.id !== productId; });
    this.save(items);
    this.updateCount();
    return true;
  },

  /* ── TOGGLE ── */
  toggle: function(product) {
    var items = this.get();
    var exists = items.find(function(i) { return i.id === product.id; });
    if (exists) {
      this.remove(product.id);
      return false;
    } else {
      this.add(product);
      return true;
    }
  },

  /* ── CHECK if in wishlist ── */
  has: function(productId) {
    return !!this.get().find(function(i) { return i.id === productId; });
  },

  /* ── COUNT ── */
  count: function() {
    return this.get().length;
  },

  /* ── UPDATE nav count badges ── */
  updateCount: function() {
    var count = this.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  /* ── UPDATE all heart buttons on page ── */
  updateHearts: function() {
    var self = this;
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      var id = parseInt(btn.dataset.productId);
      if (self.has(id)) {
        btn.classList.add('kw-wished', 'kpd-wished');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('kw-wished', 'kpd-wished');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  },

  /* ── INIT ── */
  init: function() {
    this.updateCount();
    this.updateHearts();
    this.bindButtons();
    /* Fire event so wishlist page section can render itself */
    this.fireUpdated();
  },

  /* ── BIND heart buttons ── */
  bindButtons: function() {
    var self = this;

    /* Capture phase — fires before any form submit */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      self.handleWish(btn);
    }, true);

    /* Also bind directly — catches dynamically added buttons */
    function bindDirect() {
      document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
        if (btn._kwBound) return;
        btn._kwBound = true;
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          self.handleWish(btn);
        }, true);
      });
    }
    bindDirect();
    setTimeout(bindDirect, 1000);
    setTimeout(bindDirect, 3000);
  },

  /* ── HANDLE wish toggle ── */
  handleWish: function(btn) {
    var self = this;
    var rawImage = btn.dataset.productImage || '';
    var cleanImage = rawImage.split('?')[0];

    var product = {
      id:      parseInt(btn.dataset.productId),
      title:   btn.dataset.productTitle || '',
      price:   btn.dataset.productPrice || '',
      image:   cleanImage,
      url:     btn.dataset.productUrl || '#',
      compare: btn.dataset.productCompare || '',
      tags:    (btn.dataset.productTags || '').split(',').map(function(t){ return t.trim(); })
    };

    var added = self.toggle(product);
    btn.classList.toggle('kw-wished', added);
    btn.classList.toggle('kpd-wished', added);
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');

    self.showToast(added ? '✦ Added to wishlist' : 'Removed from wishlist');
    self.updateCount();
    self.fireUpdated();
  },

  /* ── FIRE custom event — wishlist page listens to this ── */
  fireUpdated: function() {
    document.dispatchEvent(new CustomEvent('kishori:wishlist:updated'));
  },

  /* ── TOAST notification ── */
  showToast: function(msg) {
    var existing = document.getElementById('kw-toast');
    if (existing) existing.remove();

    var style = document.createElement('style');
    style.textContent = '@keyframes kwToastIn{from{opacity:0;transform:translateX(-50%) translateY(8px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}';
    document.head.appendChild(style);

    var toast = document.createElement('div');
    toast.id = 'kw-toast';
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:#1C1C1A',
      'color:#FAF7F2',
      'font-family:"DM Sans",sans-serif',
      'font-size:12px',
      'letter-spacing:0.08em',
      'padding:10px 20px',
      'border-radius:3px',
      'z-index:99999',
      'white-space:nowrap',
      'box-shadow:0 4px 20px rgba(28,28,26,0.22)',
      'animation:kwToastIn 0.28s ease'
    ].join(';');

    document.body.appendChild(toast);

    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(function() { toast.remove(); }, 300);
    }, 2200);
  },

  /* ══════════════════════════════════════
     renderWishlistPage — REMOVED intentionally.
     The Liquid section (kishori-wishlist-page.liquid)
     handles all rendering.
     This JS only manages: data, hearts, count, toast, events.
  ══════════════════════════════════════ */

};

/* ── Init on DOM ready ── */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { KishoriWishlist.init(); });
} else {
  KishoriWishlist.init();
}